import { put, takeLatest, select } from "redux-saga/effects";
import makeSelectPosts from "./selector";
import {
  GET_NEW_POST,
  GET_NEW_POST_INIT,
  GET_NEW_POST_SUCCESS,
  GET_NEW_POST_FAILED,
} from "./constants";
import { getUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";

export function* getNewPost() {
  const { postCount, loading, pageCount, rowsCount, getPosts, countPost } =
    yield select(makeSelectPosts());
  if (!getPosts.rows || (!loading && countPost <= getPosts.rows)) {
    try {
      yield put({ type: GET_NEW_POST_INIT });
      const res = yield getUtil(
        `${API.GetPost}?Page=${pageCount}&perPage=${postCount}`
      );
      if (res?.status === 200) {
        const { data } = res;
        yield put({
          type: GET_NEW_POST_SUCCESS,
          payload: {
            data: data.result,
            perPage: postCount,
            page: pageCount,
            rows: rowsCount,
          },
        });
      } else {
        yield put({ type: GET_NEW_POST_FAILED });
      }
    } catch (error) {
      throw new Error(error);
    }
  }
}

export function* getNewPosts() {
  yield takeLatest(GET_NEW_POST, getNewPost);
}
